'use client';

import { memo, ReactNode, useEffect, useState } from 'react';
import { useAccount } from 'wagmi';

type PageWrapperProps = {
  children: ReactNode;
};

// eslint-disable-next-line @typescript-eslint/promise-function-async
export const PageWrapper = memo(function PageWrapper({ children }: PageWrapperProps) {
  const account = useAccount();

  // Wagmi account status does not correctly indicate if the account is connected on the first render
  // Manage the status manually to prevent the layout from being rendered before the account is connected
  const [status, setStatus] = useState<'initial' | 'initializing' | 'initialized'>(
    // If the account is connected, we set the status to initialized
    account.status === 'connected' ? 'initialized' : 'initial',
  );

  useEffect(() => {
    if (status === 'initial' && ['connecting', 'reconnecting'].includes(account.status)) {
      // While connecting or reconnecting, we set the status to initializing
      setStatus('initializing');
    } else if (
      status === 'initializing' &&
      ['connected', 'disconnected'].includes(account.status)
    ) {
      // When the account is connected or disconnected, we set the status to initialized
      setStatus('initialized');
    }
  }, [status, account.status]);

  if (status !== 'initialized') {
    // The account is not connected, so we return null to prevent the layout from being rendered
    return null;
  }

  return children;
});
